const productsItemsNodes = document.querySelectorAll(".productitem")
const containterGridNode = document.querySelector(".results--container")
const modalDownloadNode = document.querySelector(".modal-download")
const closeButtonNode = document.querySelector(".close-button")
const downloadFileFormNode = document.querySelector("#modal-download-file-form")
const confirmDownloadNode = document.querySelector("#confirm-download")
const modalEmailInputNode = document.querySelector("#modal-email-input")
const modalNameInputNode = document.querySelector("#modal-name-input")
const acceptSpecialOffersNode = document.querySelector("#modal-accept-special-offers")

function main() {
  showButtons()
  iterateProductsItemsNodes(productsItemsNodes)
}

function showButtons() {
  const quickShopBtnsNodes = document.querySelectorAll(".productitem--action-trigger.productitem--action-qs.button-secondary")
  for(const quickShopBtnNode of quickShopBtnsNodes) {
    quickShopBtnNode.style.visibility = "visible"
  }
}

function windowOnClick(event) {
  if (event.target === modalDownloadNode) {
    toggleModal();
  }
}

function iterateProductsItemsNodes(productsItemsNodes) {
  for(const productItemNode of productsItemsNodes) {
    const productDescriptionText = productItemNode.querySelector(".productitem--info > .productitem--description").innerText.trim()
    const btnQuickshop = productItemNode.querySelector(".productitem--action-trigger.productitem--action-qs.button-secondary")
    const btnCartNode = productItemNode.querySelector(".productitem--action-trigger.productitem--action-atc.button-primary")
    if(productDescriptionText.indexOf("https://jsfn-stech.azurewebsites.net/api/downloads/zips?name=") >= 0) {
      btnCartNode.parentElement.remove()
      btnQuickshop.innerText = "Descargar"
      btnQuickshop.setAttribute("data-url-download-file", productDescriptionText)
    } else {
      console.log("Entre aqui jeje")
      btnCartNode.style.visibility = "visible"
    }
  }
}

function toggleModal() {
  modalDownloadNode.classList.toggle("show-modal")
}

function processGridClick(e) {
  const btnText = e.target.innerText.trim()
  if(e.target.classList.contains("productitem--action-qs") && btnText.toUpperCase() === "DESCARGAR") {
  	const bodyNode = document.querySelector("body")
  	setTimeout(() => bodyNode.setAttribute("class", "template-collection"), 100)
    setTimeout(() => bodyNode.setAttribute("class", "template-collection"), 250)
    const url = e.target.getAttribute("data-url-download-file").trim()
    downloadFileFormNode.setAttribute("action", url)
    toggleModal()
  }
}

async function confirmedDownloaded(e) {
  const path = downloadFileFormNode.getAttribute("action").split("name=").pop()
  if(path !== "rdworks" && path !== "sagaonlaser") e.preventDefault()
  modalDownloadNode.classList.toggle("show-modal")
  const email = modalEmailInputNode.value
  const name = modalNameInputNode.value
  const url = downloadFileFormNode.getAttribute("action")
  const acceptOffers = acceptSpecialOffersNode.checked
  fetch("https://jsfn-stech.azurewebsites.net/api/save/user", {
    method: "POST",
    body: JSON.stringify({email, name, url, acceptOffers })
  })
  .then(response => response.json())
  .then(response => console.log("Descargando archivo..."))
  .catch(error => console.error(`Ha ocurrido un error al guardar los datos: ${error.toString()}`))
  await downloadDataDirectAirtable(email, name)
  if(path !== "rdworks" && path !== "sagaonlaser") await download(url)
}

/* Helper function */
async function downloadDataDirectAirtable(email, name) {
  try {
    const response = await fetch("https://api.airtable.com/v0/app0wKV4cu3UhVjEO/usuario_descargas_helper", {
      method: "POST",
      headers: {
        "Authorization": "Bearer keyHAWcw6sWh96h5m",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        records: [
          {
            fields: {
              correo: email,
              nombre: name,
            }
          }
        ]
      })
    })
  }
  catch(error) {
    console.error(error) 
  }
}

async function download(url) {
  try {
    let response = await fetch(url, { method: "POST" })
    response = await response.json()
    const bytes = JSON.parse(response.file).data
    let base64data = btoa(new Uint8Array(bytes).reduce(function (data, byte) {
      return data + String.fromCharCode(byte)
    }, ''))
    let a = document.createElement('a')
    a.href = 'data:;base64,' + base64data
    a.download = response.filename
    a.click()
  } catch(error) {
    alert("Ha ocurrido un error al realizar la descarga, si el problema persiste contacte con soporte")
    console.log(error)
  }
}

document.addEventListener("DOMContentLoaded", main)
document.addEventListener("click", processGridClick)
downloadFileFormNode.addEventListener("submit", confirmedDownloaded)
closeButtonNode.addEventListener("click", toggleModal)
window.addEventListener("click", windowOnClick)
